import * as React from "react";

import { useCurrentChatContext } from "@editor/contexts/CurrentChatContext";

import IconButton from "@replo/design-system/components/button/IconButton";
import { MenuItem } from "@replo/design-system/components/menu/MenuItem";
import Popover from "@replo/design-system/components/popover/Popover";
import { ImagePlus, Lightbulb, Plus } from "lucide-react";

export const ActionsPopover: React.FC<{
  handleAttachImages: () => void;
}> = ({ handleAttachImages }) => {
  const { dispatchCurrentChat } = useCurrentChatContext();
  const [isOpen, setIsOpen] = React.useState(false);

  const handleInspirationAndClose = () => {
    dispatchCurrentChat({ type: "openInspirationMenu" });
  };

  return (
    <Popover.Root isOpen={isOpen} onOpenChange={setIsOpen}>
      <Popover.Anchor />
      <Popover.Trigger>
        <IconButton
          variant="secondary"
          size="base"
          icon={<Plus className="text-muted" size={16} />}
        />
      </Popover.Trigger>
      <Popover.Content
        shouldPreventDefaultOnInteractOutside={false}
        hideCloseButton
        side="top"
        align="start"
        className="flex flex-col gap-2 ml-1"
      >
        <MenuItem
          variant="default"
          startEnhancer={<ImagePlus size={16} />}
          onClick={handleAttachImages}
        >
          Attach Images
        </MenuItem>
        <MenuItem
          variant="default"
          startEnhancer={<Lightbulb size={16} />}
          onClick={handleInspirationAndClose}
        >
          Inspiration
        </MenuItem>
      </Popover.Content>
    </Popover.Root>
  );
};
